var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSanmina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 102 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-43.5584,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.156,1.414L13.156,10.836C13.156,10.836 25.065,2.876 30.757,1.414C33.868,0.614 13.156,1.414 13.156,1.414Z",
    style: {
      fill: "rgb(233,29,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-43.5584,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.38,8.348C31.38,8.348 22.312,8.615 21.601,8.169C20.89,7.725 25.538,3.716 31.38,1.769L31.38,8.348Z",
    style: {
      fill: "rgb(233,29,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-43.5584,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.29,19.548L31.458,10.049C31.458,10.049 19.567,18.038 13.88,19.515C14.134,19.726 31.29,19.548 31.29,19.548Z",
    style: {
      fill: "rgb(233,29,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-43.5584,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.241,12.582C13.241,12.582 22.307,12.293 23.021,12.736C23.731,13.179 13.257,19.162 13.257,19.162L13.241,12.582Z",
    style: {
      fill: "rgb(233,29,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.306,23.089C4.306,23.203 4.272,23.314 4.204,23.423C4.135,23.534 4.04,23.627 3.917,23.704C3.782,23.787 3.625,23.851 3.445,23.898C3.265,23.944 3.049,23.967 2.796,23.967C2.525,23.967 2.282,23.948 2.065,23.91C1.848,23.871 1.628,23.813 1.404,23.736L1.404,23.254L1.439,23.254C1.629,23.376 1.85,23.471 2.099,23.537C2.349,23.603 2.584,23.636 2.802,23.636C3.113,23.636 3.355,23.591 3.528,23.502C3.701,23.413 3.787,23.293 3.787,23.144C3.787,23.015 3.746,22.921 3.664,22.86C3.583,22.799 3.458,22.752 3.291,22.718C3.165,22.693 3.027,22.671 2.879,22.655C2.732,22.637 2.576,22.616 2.411,22.59C2.077,22.536 1.829,22.443 1.667,22.312C1.506,22.18 1.426,22.009 1.426,21.797C1.426,21.555 1.559,21.357 1.826,21.202C2.091,21.047 2.429,20.97 2.839,20.97C3.103,20.97 3.346,20.99 3.567,21.028C3.788,21.067 3.983,21.115 4.153,21.172L4.153,21.626L4.118,21.626C3.974,21.533 3.786,21.456 3.552,21.394C3.319,21.332 3.08,21.301 2.835,21.301C2.567,21.301 2.352,21.344 2.189,21.43C2.027,21.515 1.946,21.625 1.946,21.761C1.946,21.881 1.986,21.976 2.067,22.044C2.148,22.113 2.291,22.165 2.495,22.202C2.602,22.22 2.755,22.242 2.955,22.268C3.154,22.293 3.323,22.32 3.46,22.347C3.741,22.405 3.952,22.491 4.093,22.606C4.235,22.721 4.306,22.882 4.306,23.089Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97,22.78L6.311,21.359L5.649,22.78L6.97,22.78ZM8.026,23.916L7.494,23.916L7.125,23.111L5.497,23.111L5.128,23.916L4.621,23.916L5.99,21.024L6.657,21.024L8.026,23.916Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.469,23.916L10.849,23.916L9.067,21.33L9.067,23.916L8.599,23.916L8.599,21.024L9.375,21.024L11,23.386L11,21.024L11.469,21.024L11.469,23.916Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.822,23.916L15.322,23.916L15.322,21.424L14.276,23.121L13.977,23.121L12.939,21.424L12.939,23.916L12.47,23.916L12.47,21.024L13.154,21.024L14.157,22.634L15.127,21.024L15.822,21.024L15.822,23.916Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.158,23.916L16.67,23.916L16.67,23.621L17.165,23.621L17.165,21.321L16.67,21.321L16.67,21.024L18.158,21.024L18.158,21.321L17.665,21.321L17.665,23.621L18.158,23.621L18.158,23.916Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.881,23.916L21.262,23.916L19.48,21.33L19.48,23.916L19.011,23.916L19.011,21.024L19.788,21.024L21.414,23.386L21.414,21.024L21.881,21.024L21.881,23.916Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-5.85,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.794,22.78L24.134,21.359L23.472,22.78L24.794,22.78ZM25.849,23.916L25.317,23.916L24.948,23.111L23.319,23.111L22.95,23.916L22.444,23.916L23.813,21.024L24.48,21.024L25.849,23.916Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-43.5584,-4.41018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.837,2.067L32.931,2.067C33.036,2.067 33.128,2.028 33.128,1.928C33.128,1.857 33.075,1.786 32.931,1.786C32.888,1.786 32.858,1.789 32.837,1.792L32.837,2.067ZM32.837,2.516L32.708,2.516L32.708,1.705C32.774,1.695 32.841,1.685 32.937,1.685C33.06,1.685 33.14,1.711 33.188,1.747C33.237,1.783 33.263,1.837 33.263,1.915C33.263,2.022 33.192,2.086 33.105,2.112L33.105,2.119C33.177,2.131 33.224,2.196 33.241,2.316C33.261,2.442 33.278,2.49 33.292,2.516L33.155,2.516C33.138,2.49 33.118,2.415 33.103,2.309C33.083,2.206 33.03,2.166 32.927,2.166L32.837,2.166L32.837,2.516ZM32.972,1.479C32.653,1.479 32.392,1.753 32.392,2.092C32.392,2.438 32.653,2.709 32.976,2.709C33.298,2.713 33.558,2.438 33.558,2.096C33.558,1.753 33.298,1.479 32.976,1.479L32.972,1.479ZM32.976,1.366C33.372,1.366 33.688,1.689 33.688,2.092C33.688,2.503 33.372,2.823 32.972,2.823C32.575,2.823 32.251,2.503 32.251,2.092C32.251,1.689 32.575,1.366 32.972,1.366L32.976,1.366Z",
    style: {
      fill: "rgb(3,4,4)",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanmina);
export default __webpack_public_path__ + "static/media/Sanmina.51f060d20d709841a1195427ede7985d.svg";
export { ForwardRef as ReactComponent };